export default "__VITE_ASSET__0973db0f__"